import API from "../utils/api";

export const ACTION_TYPES = {
    SERVICE_CREATE: 'SERVICE_CREATE',
    SERVICE_UPDATE: 'SERVICE_UPDATE',
    SERVICE_DELETE: 'SERVICE_DELETE',
    SERVICE_FETCH: 'SERVICE_FETCH',
    SERVICE_FETCH_ALL: 'SERVICE_FETCH_ALL',
    SERVICE_PAGINATION: 'SERVICE_PAGINATION',
    SERVICE_FETCH_ALL_PACKAGES: 'SERVICE_FETCH_ALL_PACKAGES',
    SERVICE_FETCH_RANDOM_PACKAGES: 'SERVICE_FETCH_RANDOM_PACKAGES',
    SERVICE_FEATURED: 'SERVICE_FEATURED',
    SERVICE_FETCH_ALL_PRODUCTS :'SERVICE_FETCH_ALL_PRODUCTS',
    SERVICE_FETCH_ALL_COUPONS :'SERVICE_FETCH_ALL_COUPONS',
    SERVICE_SEARCHED :'SERVICE_SEARCHED',
    SERVICE_FETCH_ALL_HEADER: 'SERVICE_FETCH_ALL_HEADER'
    

}
export const getfiltered= (param) => dispatch => {
   
    API.service().filtered({
        "searchString": param,
      })
        .then(res =>{
            
            dispatch({
                type: ACTION_TYPES.SERVICE_SEARCHED,
                payload: res.data
            })
          //  onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const fetchAll = () => dispatch => {
    API.service().fetchAll()
        .then(res => {
       
            dispatch({
                type: ACTION_TYPES.SERVICE_FETCH_ALL,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}


export const fetchAllPackages = () => dispatch => {
    API.service().fetchAllPackages()
        .then(res => {
       
            dispatch({
                type: ACTION_TYPES.SERVICE_FETCH_ALL_PACKAGES,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const getFilteredAllServices = (param,onSuccess) => dispatch => {
    
    API.service().getFilteredAllServices(param)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.SERVICE_FETCH_ALL,
                payload: res.data
            })
            // switch (param.type) {
            //     case 'product':
            //         dispatch({
            //             type: ACTION_TYPES.SERVICE_FETCH_ALL,
            //             payload: res.data
            //         })
            //       break;
            //     case 'package':
            //         dispatch({
            //             type: ACTION_TYPES.SERVICE_FETCH_ALL_PACKAGES,
            //             payload: res.data
            //         })
            //         break;
            //     case 'item':
            //         dispatch({
            //             type: ACTION_TYPES.SERVICE_FETCH_ALL_PRODUCTS,
            //             payload: res.data
            //         })
            //       break;
            //       case 'coupon':
            //         dispatch({
            //             type: ACTION_TYPES.SERVICE_FETCH_ALL_COUPONS,
            //             payload: res.data
            //         })
            //       break;
               
            //   }
              
           if(onSuccess)
            onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const getFilteredAllServicesForHeader = (param,onSuccess) => dispatch => {
    
    API.service().getFilteredAllServices(param)
        .then(res =>{
            console.log('2222',res.data)
            dispatch({
                type: ACTION_TYPES.SERVICE_FETCH_ALL_HEADER,
                payload: res.data
            })
            // switch (param.type) {
            //     case 'product':
            //         dispatch({
            //             type: ACTION_TYPES.SERVICE_FETCH_ALL,
            //             payload: res.data
            //         })
            //       break;
            //     case 'package':
            //         dispatch({
            //             type: ACTION_TYPES.SERVICE_FETCH_ALL_PACKAGES,
            //             payload: res.data
            //         })
            //         break;
            //     case 'item':
            //         dispatch({
            //             type: ACTION_TYPES.SERVICE_FETCH_ALL_PRODUCTS,
            //             payload: res.data
            //         })
            //       break;
            //       case 'coupon':
            //         dispatch({
            //             type: ACTION_TYPES.SERVICE_FETCH_ALL_COUPONS,
            //             payload: res.data
            //         })
            //       break;
               
            //   }
              
           if(onSuccess)
            onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const getFeatured = (param) => dispatch => {
    
    API.service().getFilteredAllServices(param)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.SERVICE_FEATURED,
                payload: res.data
            })
          //  onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const fetchRandomPackages = (param) => dispatch => {
    API.service().fetchRandomPackages(param)
        .then(res => {
       
            dispatch({
                type: ACTION_TYPES.SERVICE_FETCH_RANDOM_PACKAGES,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const Pagination = (page = 1, limit = 5, title = "") => dispatch => {
    API.service().fetchPagination(page, Math.abs(limit), title)
        .then(res =>{
          
            dispatch({
                type: ACTION_TYPES.SERVICE_PAGINATION,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const packagePagination = (page = 1, limit = 5, title = "") => dispatch => {
    API.service().fetchPagfetchPackagesPaginationination(page, Math.abs(limit), title)
        .then(res =>{
          
            dispatch({
                type: ACTION_TYPES.SERVICE_PAGINATION,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const fetchById = (id, onSuccess) => dispatch => {
    API.service().fetchById(id)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.SERVICE_FETCH,
                payload: res.data
            })
            onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const create = (input, onSuccess) => dispatch => {
    API.service().create(input)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.SERVICE_CREATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const update = (id, input, onSuccess) => dispatch => {
   
    API.service().update(id, input)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.SERVICE_UPDATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const Delete = (id, onSuccess) => dispatch => {
    API.service().delete(id)
        .then(res =>{
          
            dispatch({
                type: ACTION_TYPES.SERVICE_DELETE,
                payload: res.data.id
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}